import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Group, TagDefinition, GroupFromTags } from '../../models';
import { ILoggerService, IStoreService } from '../../services';
import { groupSelected, guidEmpty, tagSaved } from '../../common';
import { IGroupsStoreService } from '../../stateManagement';

class CreateGroupController implements angular.IComponentController {
    groupName: string;
    groupType: string;
    isLoading: boolean;
    loadingMessage: string;
    position: string;
    selectedGroup: Group;
    tags: TagDefinition[];

    private _groupService: IGroupsStoreService;

    static $inject = [
        '$scope',
        '$rootScope',
        'storeService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _storeService: IStoreService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.groupType = 'new';
        this.groupName = '';
        this.position = 'child';
        this._groupService = this._storeService.dispatchers().groups;
        this._$scope.$on(groupSelected, (_event, data) => {
            this.selectedGroup = data;
        });
    }

    isCreatable(): boolean {
        return this.selectedGroup &&
            ((this.groupType === 'new' && this.position && this.groupName &&
                (this.selectedGroup.name !== 'root' ||
                    (this.selectedGroup.name === 'root' && this.position !== 'sibling')))
                || (this.groupType === 'existing' && this.selectedGroup.name !== 'root'));
    }

    createGroup(): angular.IPromise<Group | void> {
        this.isLoading = true;
        const tags = this.tags;
        const postObject = this.createPostObject(tags);
        return this._groupService
            .createOrUpdateWithTags(postObject)
            .then(group => {
                this._loggerService.logSuccess(`${tags.length} identifiers added to group ${this.groupName}.`);
                this.isLoading = false;
                this._$rootScope.$broadcast(tagSaved, tags);
                return group;
            })
            .catch((reason) => {
                this._loggerService.logError(reason);
                this.isLoading = false;
            });

    }

    private createPostObject(tags): GroupFromTags {
        const postObject = {
            parentGuid: '',
            name: '',
            guid: '',
            tags: _.map(tags, 'guid')
        };
        if (this.groupType === 'new') {
            postObject.guid = guidEmpty;
            postObject.name = this.groupName;
            if (this.selectedGroup) {
                if (this.position === 'sibling') {
                    postObject.parentGuid = this.selectedGroup.parentGUID;
                } else {
                    postObject.parentGuid = this.selectedGroup.guid;
                }
            }
        } else {
            postObject.guid = this.selectedGroup.guid;
        }
        return postObject;
    }
}

export const wtCreateGroup: ComponentDefinition = {
    componentId: 'wtCreateGroup',
    controller: CreateGroupController,
    template: require('./createGroup.component.html'),
    controllerAs: 'vm',
    bindings: {
        tags: '='
    }
};
